import api from '../../../services/Api';
import { IAuditoriaAdiantamentoFuncionariosResultado } from '../interfaces/IAuditoriaAdiantamentoFuncionarios';

export const AuditoriaAdiantamentoFuncionariosService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaAdiantamentoFuncionariosResultado> {
    const response = await api.get<IAuditoriaAdiantamentoFuncionariosResultado>('auditoria-adiantamento-funcionarios/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        adiantamentosEstagnados: [],
        adiantamentosConciliados: [],
      }
    );
  },
};
